import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import appConfig from '@nerdwallet/app-config';

import Image from '@nerdwallet/react-image';
import Type from '@nerdwallet/react-typography';

class CompanyExecutiveTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      desktopImg: `${appConfig.ASSETS_URL}/${this.props.image}`,
    };
  }

  render() {
    const {
      name,
      title,
      description,
      image,
      imageMobile,
      imageAlt,
      imageRollover,
    } = this.props;

    return (
      <div
        className={classNames([
          'executive__inner',
          classes('margin-horizontal-auto'),
          classes('text-align-left'),
          classes('display-block'),
          classes('display-flex--wide'),
          classes('flex-direction-row--wide'),
          classes('align-items-flex-start--wide'),
          classes('width-100'),
          classes('width-auto--wide'),
          classes('margin-bottom-5'),
        ])}
      >
        {imageMobile && (
          <div
            className={classNames([
              'executive__image',
              classes('display-none--wide'),
              classes('margin-right-4--wide'),
            ])}
          >
            <Image
              src={`${appConfig.ASSETS_URL}/${imageMobile}`}
              alt={imageAlt}
              naturalWidth={678}
              naturalHeight={452}
              placeholdercolor="transparent"
              className={classNames([
                'executive__image',
                classes('margin-bottom-3'),
              ])}
            />
          </div>
        )}
        {image && (
          <div
            className={classNames([
              'executive__image',
              classes('display-none'),
              classes('display-block--wide'),
              classes('margin-right-4--wide'),
            ])}
          >
            <Image
              src={this.state.desktopImg}
              alt={imageAlt}
              naturalWidth={400}
              naturalHeight={496}
              placeholdercolor="transparent"
              className={classNames([
                'executive__image',
                classes('margin-bottom-3'),
              ])}
              onMouseEnter={() => {
                this.setState({
                  desktopImg: `${appConfig.ASSETS_URL}/${imageRollover}`,
                });
              }}
              onMouseOut={() => {
                this.setState({
                  desktopImg: `${appConfig.ASSETS_URL}/${image}`,
                });
              }}
            />
          </div>
        )}
        <div className={classNames(['executive__description'])}>
          {name && (
            <Type
              size="3"
              chronicle
              className={classNames([
                'executive__name',
                classes('margin-bottom-1'),
              ])}
            >
              {name}
            </Type>
          )}
          {title && (
            <Type
              size="1"
              gotham
              className={classNames([
                'executive__title',
                classes('margin-bottom-3'),
              ])}
            >
              {title}
            </Type>
          )}
          {description && (
            <Type
              size="1"
              gotham
              className={classNames(['executive__description'])}
            >
              {description}
            </Type>
          )}
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
CompanyExecutiveTile.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  imageMobile: PropTypes.string,
  imageAlt: PropTypes.string,
  imageRollover: PropTypes.string,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
CompanyExecutiveTile.displayName = 'Company Executive Tile';

export default CompanyExecutiveTile;
